import React from 'react'
import "./Home.css"
import Profile from './Profile'
import FooterCurve from './FooterCurve'

const Home = () => {
	return (
		<>
		 <div id="home">
			<Profile />
			<FooterCurve />
		</div>

		</>
	)
}

export default Home
